import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { connect } from "react-redux";
import { sidemenuFooterWrap } from "../componentCommon";
import PhotoSeriesEl from './PhotoSeriesEl';
import { getSerLi } from '../../actions'
import "./PhotoDocumentation.scss";
import PhotoSer from '../../models/PhotoSer';

const mapStateToProps = state => ({
  phSN: state.phSerLi.phSN,
});
const mapDispatchToProps = dispatch => ({
  getSerLi: (payload) => dispatch(getSerLi(payload))
});

let PhotoDocumentation = ({ match, phSN, getSerLi }) => {
  let groupSlug = match.params.hasOwnProperty('groupSlug') ? match.params.groupSlug : '';
  let serType = match.params.hasOwnProperty('serType') ? match.params.serType : '';

  useEffect(
    function() {
      if (groupSlug != '') {
        const sType = (serType == 'ph' ? 'fotografije' : 'neknjizna_gradja' );
        console.log('aa');

        getSerLi({$and: [{ group: groupSlug }, { sType }]});
      }             
    },
    [groupSlug, serType]
  );

  // console.log(phSN);
  const phSerLi = phSN.map((phSer, ind) => {
      // let phS = new PhotoSer();
      // phS.obSet(phSer);
      return (
        <Col key={'ph-el-' + ind} className="ph-s-el" style={{ marginTop: ( ind > 0 ? '2em' : '0em' ) }}>
          <PhotoSeriesEl phSer={ phSer } />
        </Col>
      );    
    }  
  );
  
  return (
    <Container
      className="container-photo-documentation"
      sm={{ span: 12 }}
      md={{ span: 12 }}
      lg={{ span: 12 }}
      xl={{ span: 12 }}
      >      
      <Row>
        { phSerLi }
      </Row>
    </Container>
  );
} 


PhotoDocumentation = sidemenuFooterWrap(PhotoDocumentation);
export default connect(mapStateToProps, mapDispatchToProps)(PhotoDocumentation);
